(function () {
  if (window.__msShareButtonInit) return;
  window.__msShareButtonInit = true;

  function closePanel(root) {
    var panel = root.querySelector('[data-share-panel]');
    var trigger = root.querySelector('[data-share-trigger]');
    if (panel) panel.setAttribute('hidden', '');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function togglePanel(root) {
    var panel = root.querySelector('[data-share-panel]');
    var trigger = root.querySelector('[data-share-trigger]');
    if (!panel) return;
    var isHidden = panel.hasAttribute('hidden');
    if (isHidden) {
      document.querySelectorAll('[data-share-root]').forEach(function (r) {
        if (r !== root) closePanel(r);
      });
      panel.removeAttribute('hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    } else {
      closePanel(root);
    }
  }

  function fallbackCopy(text, done) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      document.execCommand('copy');
    } catch (err) {}
    document.body.removeChild(textarea);
    done();
  }

  function copyLink(root) {
    var shareText = root.dataset.shareText || root.dataset.url;
    var copyTextEl = root.querySelector('[data-share-copy-text]');
    var original = copyTextEl ? copyTextEl.dataset.default || copyTextEl.textContent : '';
    if (copyTextEl && !copyTextEl.dataset.default) {
      copyTextEl.dataset.default = copyTextEl.textContent;
      original = copyTextEl.textContent;
    }

    var done = function () {
      if (!copyTextEl) return;
      copyTextEl.textContent = 'Copied!';
      setTimeout(function () {
        copyTextEl.textContent = original;
        closePanel(root);
      }, 1200);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareText).then(done).catch(function () {
        fallbackCopy(shareText, done);
      });
    } else {
      fallbackCopy(shareText, done);
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-share-trigger]');
    if (trigger) {
      var root = trigger.closest('[data-share-root]');
      if (root) {
        e.stopPropagation();
        togglePanel(root);
      }
      return;
    }

    var copyBtn = e.target.closest('[data-share-copy]');
    if (copyBtn) {
      var copyRoot = copyBtn.closest('[data-share-root]');
      if (copyRoot) copyLink(copyRoot);
      return;
    }

    var whatsappLink = e.target.closest('[data-share-whatsapp]');
    if (whatsappLink) {
      var waRoot = whatsappLink.closest('[data-share-root]');
      if (waRoot) {
        var shareText = waRoot.dataset.shareText || waRoot.dataset.url;
        whatsappLink.href = 'https://wa.me/?text=' + encodeURIComponent(shareText);
      }
      return;
    }

    document.querySelectorAll('[data-share-root]').forEach(function (root) {
      if (!root.contains(e.target)) closePanel(root);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-share-root]').forEach(closePanel);
    }
  });
})();
